import { RawLocation } from 'vue-router'
import { SysNotifyListOutput as Notification } from '@/api/swagger'
// import { Actions as fireAcceptActions } from './notify-handler-modules/fire-accept';
// import { Actions as fireReportActions } from './notify-handler-modules/fire-report';
// import { Actions as expertActions } from './notify-handler-modules/expert';
// import { Actions as flowPaddingActions } from './notify-handler-modules/flow-padding';
// import { Actions as fireTestActions } from './notify-handler-modules/fire-test';
// import { Actions as EngineeringActions } from './notify-handler-modules/engineering';
// import { Actions as SupplementaryDocument } from './notify-handler-modules/supplementary-document';
// import { Actions as Enterprise } from './notify-handler-modules/enterprise';

interface Callback {
  closeDialog?: boolean // 是否关闭弹窗
  redirect?: RawLocation // 是否要重定向路由
}

/**
 * 处理通知点击后的事件，默认点击后会标记为已读
 * 而这里就是进行额外的处理，例如跳转到 xxx 页面，打开 xxx 提示等
 * @param notify
 * @returns { Promise<Callback> }
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function handlerClick(notify: Notification): Promise<Callback> {
  return {}
}
